<script>
import api from '../../Api/address'

export default {
    props: {
        countries: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            newAddressType: null,
            address: this.defaultAddress(),
            errors: {}
        }
    },

    methods: {
        setNewAddressType(addressType) {
            this.newAddressType = addressType
        },
        async create() {
            this.address.type = this.newAddressType

            try {
                let response = await api.add(this.address)

                this.address = this.defaultAddress()
                this.newAddressType = null

                this.$bus.$emit('address-added', response.data)

                return response.data
            } catch (error) {
                console.log(error)
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors
                }

                this.$bus.$emit('address-error', error.response.data)
            }

            return null
        },

        defaultAddress() {
            return {
                street: '',
                houseNumber: '',
                city: '',
                state: '',
                postCode: '',
                countryId: '',
                billingName: '',
                taxNumber: '',
                type: ''
            }
        }
    },

    render() {
        return this.$scopedSlots.default({
            newAddressType: this.newAddressType,
            setNewAddressType: this.setNewAddressType,
            address: this.address,
            errors: this.errors,
            create: this.create
        })
    }
}
</script>
